// TODO: Find fix for the CSS class "o-drawer__content". It was intended to wrap around everything inside of wrapper, but prevents scrolling.
// TODO: Use closeButton prop.

import React from 'react';
import PropTypes from 'prop-types';
import ButtonRow from '../ButtonRow/ButtonRow';

interface DrawerProps {
    placement?: 'right' | 'left';
    size?: 'full' | 'narrow';
    type?: 'default' | 'hybrid';
    isHidden?: boolean;
    clickOutsideToClose?: boolean,
    header?: React.ReactNode;
    actions?: React.ReactNode;
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
    // Functions
    onClose?: () => void;
}

/**
 * A drawer to house an area that pops up from either side.
 * 
 * ## _
 * ### Arguments
 * @param {string} placement - One of "left" or "right". Determines the side the drawer comes from.
 * @param {string} size - One of "full" or "narrow". Determines the width of the drawer.
 * @param {string} type - One of "default" or "hybrid". Default drawers pop up from one side, and hybrid drawers rest in the main screen.
 * @param {boolean} isHidden - Controls the visibility of the drawer. Defaults to true.
 * @param {boolean} clickOutsideToClose - A flag that permits a user to click the outside area to close the drawer.
 * @param {boolean} closeButton - A flag that adds a close button to the top right corner of the drawer. [UNUSED]
 * @param {React.ReactNode} header - Node that populates the top heading of the drawer.
 * @param {React.ReactNode} actions - Buttons to populate the button row at the bottom of the drawer.
 * @param {React.ReactNode} children - The contents inside the drawer.
 * @param {string} className - CSS classes to apply to the drawer.
 * 
 * ## _
 * ### Functions
 * @param {function} onClose - Function that is called when the modal is closed.
 */
class Drawer extends React.Component<DrawerProps> {
    static propTypes = {
        placement: PropTypes.oneOf(['right', 'left']),
        size: PropTypes.oneOf(['full', 'narrow']),
        type: PropTypes.oneOf(['default', 'hybrid']),
        isHidden: PropTypes.bool,
        clickOutsideToClose: PropTypes.bool,
        closeButton: PropTypes.bool,
        header: PropTypes.node,
        actions: PropTypes.node,
        children: PropTypes.node,
        className: PropTypes.string,
        onClose: PropTypes.func,
    }

    static defaultProps = {
        placement: 'right',
        size: 'full',
        type: 'default',
        isHidden: true,
        className: "",
    }

    handleClickOutside = () => {
        const { clickOutsideToClose, onClose } = this.props;
        if(clickOutsideToClose && onClose){
            onClose();
        }
    }

    render() {
        const { placement, size, type, isHidden, header, actions, children, className, onClose } = this.props;

        let classes = 'o-drawer';
        classes += ` o-drawer--${placement}`;
        classes += ` o-drawer--${size}`;
        classes += ` o-drawer--${type}`;
        
        // A hybrid drawer probably shouldn't ever be hidden, right?
        if (type !== 'hybrid') classes += ` o-drawer--${isHidden ? 'hidden' : 'shown'}`;
        if (actions) classes += ' o-drawer--has-button-row';
        if (className) classes += ` ${className}`

        return (
            <div className={classes}>
                <div className="o-drawer__overlay" onClick={this.handleClickOutside}/>
                <div className="o-drawer__wrapper">
                    {/* Wrap the drawer in 'o-drawer__content' if it is a hybrid type. */}
                    {
                        type === 'hybrid' ?
                        <div className="o-drawer__content">
                            {header}
                            <div className="o-drawer__inner" onClick={e => e.stopPropagation()}>
                                {children}
                            </div>
                            {/* {footer && <div className="o-drawer__footer">{footer}</div>} */}
                            {actions && <ButtonRow className='o-drawer__fixed-btn-row'>{actions}</ButtonRow>}
                        </div>
                        :
                        <>
                            {header}
                            <div className="o-drawer__inner" onClick={e => e.stopPropagation()}>
                                {children}
                            </div>
                            {/* {footer && <div className="o-drawer__footer">{footer}</div>} */}
                            {actions && <ButtonRow className='o-drawer__fixed-btn-row'>{actions}</ButtonRow>}
                        </>
                    }
                </div>
            </div>
        );
    }
}

export default Drawer;